// extracted by mini-css-extract-plugin
module.exports = {"icon":"Tvshows_icon__v2dsK","question":"Tvshows_question__327yo"};